export default __webpack_public_path__ + "static/media/support-notes-logo-clarin.fb725039.svg";